import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';

import { DashboardService } from '../../dashboard/shared/dashboard.service';
import { RetentionRow } from '../../dashboard/shared/retention-row.model';
import { ChartData, ChartDataset } from 'src/app/shared/chart/chart-data.model';
import { ChartService } from 'src/app/shared/chart/chart.service';
import { MonthlyAddDrops } from 'src/app/dashboard/shared/monthly-add-drops.interface';
import { TranslationService } from 'src/app/shared';
import { UIChart } from 'primeng/chart';

@Component({
  selector: 'wl-dashboard-neo-retention-monthly',
  templateUrl: 'dashboard-neo-retention-monthly.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [DashboardService, ChartService],
  styleUrls: ['dashboard-neo-retention-monthly.component.less'],
    standalone: false
})
export class DashboardNeoRetentionMonthlyComponent implements OnInit {
  public rawData: MonthlyAddDrops[];
  public totalAdds: number;
  public totalDrops: number;
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean;

  public chartData: ChartData;
  public chartOptions: any;
  public colors: string[];
  @ViewChild('addDropChart') addDropChart: UIChart;

  public constructor(
    private _dashboardService: DashboardService,
    private _translationService: TranslationService,
    private _chartService: ChartService
  ) {
    this.isLoading = true;
  }

  ngOnInit() {
    this.chartOptions = {
      plugins: {
        legend: {
          position: false,
        },
      },
      scales: {
        x: {
          stacked: true,
        },
      },
    };

    this.getMonthlyAddDropReport();
  }

  public getMonthlyAddDropReport() {
    this._dashboardService.getMonthlyAddDropReport(this.startDate, this.endDate).then((data: MonthlyAddDrops[]) => {
      this.chartData = new ChartData();
      this.chartData.datasets.push(new ChartDataset());
      this.rawData = data;

      let tmpColors = this._chartService.getChartColors(4);

      this.colors = [tmpColors[1], tmpColors[3], tmpColors[0]];
      this.translateToChartData();

      if (this.addDropChart) {
        this.addDropChart.refresh();
      }
      this.isLoading = false;
    });
  }

  private translateToChartData() {
    for (let row of this.rawData) {
      this.chartData.labels.push(this._translationService.getInstantTitlecase(`common.month-names.${row.Month}`));
      this.chartData.datasets[0].data.push(row.Adds);
      this.chartData.datasets[1].data.push(row.Drops * -1);
    }

    this.chartData.datasets[0].backgroundColor = [this.colors[0]];
    this.chartData.datasets[0].hoverBackgroundColor = [this.colors[2]];
    this.chartData.datasets[0].label = this._translationService.getInstantTitlecase('dashboard.retention.adds');

    this.chartData.datasets[1].backgroundColor = [this.colors[1]];
    this.chartData.datasets[1].hoverBackgroundColor = [this.colors[2]];
    this.chartData.datasets[1].label = this._translationService.getInstantTitlecase('dashboard.retention.drops');

    this.totalAdds = this.rawData.map((x) => x.Adds).reduce((total, current) => total + current, 0);
    this.totalDrops = this.rawData.map((x) => x.Drops).reduce((total, current) => total + current, 0);
  }
}
